import React, { useEffect, useState, createContext, useContext } from "react";
import api from "../lib/api";

const Ctx = createContext([]);

export const DEFAULT_THRESHOLDS = [
  { min: 100, label: "Hedef Üstü", color: "#16A34A" },
  { min: 90, label: "İyi", color: "#2563EB" },
  { min: 80, label: "İzlenmeli", "color": "#D97706" },
  { min: 70, label: "Düşük", color: "#EA580C" },
  { min: 0, label: "Kritik", color: "#DC2626" },
];

export function ThresholdProvider({ children }) {
  const [thresholds, setThresholds] = useState(DEFAULT_THRESHOLDS);
  useEffect(() => {
    api.get("/settings/thresholds").then((r) => setThresholds(r.data)).catch(() => {});
  }, []);
  return <Ctx.Provider value={{ thresholds, setThresholds }}>{children}</Ctx.Provider>;
}

export const useThresholds = () => useContext(Ctx);

export function effColor(value, thresholds) {
  if (value === null || value === undefined) return "#6B7280";
  const t = [...(thresholds || DEFAULT_THRESHOLDS)].sort((a, b) => b.min - a.min);
  for (const th of t) if (value >= th.min) return th.color;
  return t[t.length - 1]?.color || "#DC2626";
}

export function effLabel(value, thresholds) {
  if (value === null || value === undefined) return "-";
  const t = [...(thresholds || DEFAULT_THRESHOLDS)].sort((a, b) => b.min - a.min);
  for (const th of t) if (value >= th.min) return th.label;
  return t[t.length - 1]?.label || "Kritik";
}
